
//temporary hardcoded class to assist with format and domain validation of emails
export default class EmailHelper {

    private static domains : Array<string> = [
        'karasdates.com',
        'meatcorp.com',
        'thinkninjas.co.za',
        'federatedfarmers.co.za',
        'zzfresh.com',
        'dutoitservices.co.za',
        'zz2.co.za',
        'spiesboerdery.co.za'
    ];

    public static validateFormat(email : string) : boolean {
        // eslint-disable-next-line no-useless-escape
        const validFormat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return validFormat.test(email);
    }

    public static validateDomain(email : string) : boolean {
        const domainPattern = this.domains.map(domain => domain.replace(/\./g, '\\.')).join('|');

        // eslint-disable-next-line no-useless-escape
        const validDomain = new RegExp(`^(([^<>()[\\]\\\\.,;:\\s@\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\"]+)*)|(\\\".+\\\"))@((${domainPattern}))$`);
        return validDomain.test(email);
    }
}
